import React from 'react';
import PropTypes from 'prop-types';
import FeaturedImage from '../FeaturedImage';
import useSettingsContext from '../../context/useSettingsContext';

function Post(props) {
  const {
    postType,
    displayAuthor
  } = useSettingsContext();

  const {post} = props;
  let featuredImage;
  let author;

  Post.propTypes = {
    post: PropTypes.object
  }

  if (post.featured_image !== undefined && post.featured_image) {
    featuredImage = <a href={post.link}>
      <figure className="post-card__image-wrapper image-wrapper">
        <FeaturedImage
          imageSize={'card-image-link-4'} 
          image={post.featured_image}
          srcset={post.featured_image}
          className="post-card__image"
        ></FeaturedImage>
      </figure>
    </a>
  }

  if (post.the_author !== undefined && displayAuthor) {
    author = <div className="post-card__author">By {post.the_author}</div>
  }

  return (
    <article id={`${postType}-${post.id}`} className="post-card">
      {featuredImage}

      {post.eight29_custom.primary_category && <span className="post-card__category">{post.eight29_custom.primary_category}</span>}

      <h3 className="post-card__title"><a href={post.link} dangerouslySetInnerHTML={{__html: post.title.rendered}}></a></h3>

      {author}
    </article>
  );
}

export default Post; 